import React, { Fragment, Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

import { requestPasswordReset } from 'api';
import { Logo, Button, Container, Text, Box } from 'components';

import RequestResetForm from './RequestResetForm';

class RequestReset extends Component {
  state = {
    form: {
      email: '',
    },
    errors: {},
    success: {}
  };

  onChange = e => {
    const { name, value } = e.target;
    const { form } = this.state;
    this.setState({
      errors: {},
      form: { ...form, [name]: value },
    });
  };

  onSubmit = e => {
    e.preventDefault();
    this.setState({ errors: {}, success: {} });

    const valid = this.validateForm();

    if (valid) {
      const { form } = this.state;
      const { email } = form;

      requestPasswordReset({ email })
        .then(res => {
            this.setState({ success: { reset: res.data.message } });
        })
        .catch(err => {
          let message = 'Something went wrong.';
          if (err.response) {
            message =
              (err.response.data.errors && err.response.data.errors[0]) ||
              'Could not reset password. Please try again';
          }
          this.setState({ errors: { reset: message } });
        });
    }
  };

  validateForm = () => {
    const { form } = this.state;
    const fields = ['email'];
    let errors = {};

    fields.forEach(key => {
      const value = form[key];
      // Required
      if (value === '' || value === undefined) {
        errors[key] = { value, error: 'required' };
      }
    });

    this.setState({ errors });

    return Object.keys(errors).length === 0;
  };

  render() {
    const { form, errors, success } = this.state;

    return (
      <Fragment>
        <Box className="hero hero-login">
          <Container>
            <Box className="flex flex-row" py="4">
              <Link to="/">
                <Logo white />
              </Link>
              <Box ml="auto">
                <Button to="/" secondary>
                  Back
                </Button>
              </Box>
            </Box>
          </Container>
          <Container>
            <Text py="4" display="h1">
              Reset Your Password
            </Text>
            <Text py="4" display="p">
              Forgotten your password? Don't worry, we'll email you a reset link.
            </Text>

            <Box my="4">
              <RequestResetForm
                form={form}
                errors={errors}
                success={success}
                onChange={this.onChange}
                onSubmit={this.onSubmit}
              />
            </Box>
            <Box className="flex" py="4">
              <Box mr="3" pr="3" border="right">
                <img
                  alt="secure"
                  className="mt-3"
                  src={require('../../images/hero-security.svg')}
                  width={19}
                  height={23}
                />
              </Box>
              <Text mb="0">
                Your details are secured by 256 bit encryption
                <br className="br-md" />
                and monitored 24/7
              </Text>
            </Box>
          </Container>
          {/* <div className="hero-image" /> */}
        </Box>
      </Fragment>
    );
  }
}

export default withRouter(RequestReset);
